import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { Table } from "antd";
import * as React from "react";
import strings from "../../../config/localization";
import type { ColumnsType } from "antd/es/table";
import Grid from "@mui/material/Grid";
import { Button, Stack } from "@mui/material";
import ButtonGroup from "../../../components/Buttons/ButtonGroup";
import { getBaseURL } from "../../constants";

interface Personnel {
  designationId: string;
  designationName: string;
  district: string;
  id: string;
  idNumber: string;
  mobileNumber: string;
  name: string;
  organization: string;
  serialNo: number;
}

interface Props {
  personnel: Personnel[];
  onSubmitHandler: (personnel: Personnel[]) => void;
  state: boolean;
}

export default function SelectPersonnel(props: Props) {
  const [selectedPersonnel, setSelectedPersonnel] = React.useState<Personnel[]>(
    [],
  );

  const columns: ColumnsType<Personnel> = [
    {
      title: strings.photo,
      dataIndex: "photo",
      key: "photo",
      render: (text, record, index) => (
        <img
          src={`${getBaseURL()}/personnel/getPhoto/${record.id}`}
          height={50}
          alt={""}
        />
      ),
    },
    {
      title: strings.name,
      dataIndex: "name",
      key: "name",
    },
    {
      title: strings.idNumber,
      dataIndex: "idNumber",
      key: "idNumber",
    },
    {
      title: strings.mobileNumber,
      dataIndex: "mobileNumber",
      key: "mobileNumber",
    },
  ];

  const rowSelection = {
    onChange: (selectedRowKeys: React.Key[], selectedRows: Personnel[]) => {
      console.log(
        `selectedRowKeys: ${selectedRowKeys}`,
        "selectedRows: ",
        selectedRows,
      );
      setSelectedPersonnel([...selectedRows]);
    },
    getCheckboxProps: (record: Personnel) => ({
      disabled: record.name === "Disabled User", // Column configuration not to be checked
      name: record.name,
    }),
  };

  return (
    <div>
      <Dialog open={props.state} fullScreen>
        <DialogTitle id="alert-dialog-title">
          {strings.selectPersonnel}
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            <Table
              virtual
              scroll={{ y: 300 }}
              columns={columns}
              dataSource={props.personnel}
              pagination={false}
              rowKey="id"
              rowSelection={{
                type: "checkbox",
                ...rowSelection,
              }}
            />
            <ButtonGroup>
              <Button
                variant="contained"
                onClick={() => {
                  props.onSubmitHandler(selectedPersonnel);
                }}
              >
                {strings.select}
              </Button>
              <Button
                variant="contained"
                onClick={() => {
                  props.onSubmitHandler([]);
                }}
              >
                {strings.cancel}
              </Button>
            </ButtonGroup>
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
}
